import { Component, Input, ViewEncapsulation } from '@angular/core';
import { DecimalPipe } from '@angular/common';
import { TranslocoModule } from '@jsverse/transloco';
import { SearchService } from '@ukam/core/services/search.service';

@Component({
    selector: 'app-search-count',
    templateUrl: './search-count.component.html',
    encapsulation: ViewEncapsulation.None,
    standalone: true,
    imports: [TranslocoModule, DecimalPipe]
})
export class AppSearchCountComponent {
    @Input({ required: true }) searchService!: SearchService<any>;
    @Input() align: 'start' | 'center' | 'end' = 'start';
}
